export enum TenantSettingKey {
  THEME_CONFIG = 'theme_config',
  // supported_languages
  SUPPORTED_LANGUAGES = 'supported_languages',
  // default_language
  DEFAULT_LANGUAGE = 'default_language',
  // default duration for trial
  TRIAL_DURATION_SECONDS = 'trial_duration_seconds',
  USAGE_DURATION_SECONDS = 'usage_duration_seconds',
  SURVEY_DURATION_SECONDS = 'survey_duration_seconds',
  EXTEND_DURATION_SECONDS = 'extend_duration_seconds',
}
